// src/api/axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: 'https://anydev.com-eg.net/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const storage = localStorage.getItem('accessToken') ? localStorage : sessionStorage;

    const token = storage.getItem('accessToken');
    const companyId = '551001'; // ثابت حسب طلبك
    const language = 'ar';

    // ✅ تأكد من إرسال الهيدر المطلوبة بدقة
    if (token) {
      config.headers['AccessToken'] = token; // ❗️بدلاً من Authorization
    }

    config.headers['CompanyID'] = companyId;
    config.headers['Language'] = language;

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
